import { useTranslation } from 'react-i18next';
import { Modal, ModalActionType, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface DeleteReportConfirmationModalProps {
    isOpen: boolean;
    count?: number;
    deleteInProgress?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeleteReportConfirmationModal({
    isOpen,
    count = 1,
    deleteInProgress,
    onConfirm,
    onCancel,
}: DeleteReportConfirmationModalProps) {
    const { t } = useTranslation(I18nNamespace.REPORTS);
    const isBulk = count > 1;

    return (
        <Modal
            isOpen={isOpen}
            title={t(
                isBulk
                    ? 'deleteConfirmModal.titlePlural'
                    : 'deleteConfirmModal.title',
                { count },
            )}
            description={t(
                isBulk
                    ? 'deleteConfirmModal.bodyPlural'
                    : 'deleteConfirmModal.body',
                { count },
            )}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={deleteInProgress}
            submitText={t(
                isBulk
                    ? 'deleteConfirmModal.submitPlural'
                    : 'deleteConfirmModal.submit',
                { count },
            )}
            size="small"
            variant={ModalVariant.PLAIN}
            actionType={ModalActionType.DANGER}
            closeOnOutsideClick
            contentTestId="delete-report-confirm-modal"
            submitButtonTestId="delete-report-confirm-submit"
        />
    );
}
